import { defineComponent as l, computed as n, openBlock as r, createElementBlock as c, normalizeStyle as o, normalizeClass as u } from "vue";
const p = /* @__PURE__ */ l({
  __name: "BaseSkeleton",
  props: {
    width: { default: "100%" },
    height: { default: "1rem" },
    variant: { default: "text" },
    class: { default: "" }
  },
  setup(s) {
    const t = s, a = n(() => {
      const e = ["skeleton-base", "animate-pulse"];
      switch (t.variant) {
        case "circular":
          e.push("skeleton-circular");
          break;
        case "rectangular":
          e.push("skeleton-rectangular");
          break;
        case "text":
        default:
          e.push("skeleton-text");
          break;
      }
      return t.class && e.push(t.class), e.join(" ");
    });
    return (e, i) => (r(), c("div", {
      class: u(a.value),
      style: o({
        width: t.width,
        height: t.height
      })
    }, null, 6));
  }
});
export {
  p as default
};
